module.exports = __webpack_public_path__ + "static/petition_highlight-bff7eff11b4229bc6c643d2ecfff4e8c.jpg";